export default () => {
    const squareInput = document.getElementById('square-meters') as HTMLInputElement;
    const layersInput = document.getElementById('layers') as HTMLInputElement;
    const coverageInput = document.getElementById('coverage') as HTMLInputElement;
    const resultOutput = document.getElementById('liters-required') as HTMLElement;

    if (!squareInput || !layersInput || !coverageInput || !resultOutput) return;

    const getCoverage = () => parseInt(coverageInput.value) || 1;

    const calculateLiters = () => {
        const squareMeters = parseInt(squareInput.value) || 0;
        const layers = parseInt(layersInput.value) || 1;
        const coverage = getCoverage();

        const rawLiters = (squareMeters * layers) / coverage;
        const roundedLiters = Math.ceil(rawLiters);

        resultOutput.textContent = roundedLiters.toString();
    };

    squareInput.addEventListener('input', calculateLiters);
    layersInput.addEventListener('input', calculateLiters);

    calculateLiters();
}